import { render } from "./ViewTariffZonePage.vue?vue&type=template&id=3199ad88&ts=true"
import script from "./ViewTariffZonePage.vue?vue&type=script&lang=ts"
export * from "./ViewTariffZonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__